import React, { forwardRef, ReactElement } from 'react';

import classNames from 'classnames';

import { BREADCRUMB_CLASS } from '../../utils/constants';
import { ChevronSmallRight } from '../Icon/components';
import * as Styled from './Breadcrumb.styles';
import { IBreadcrumbProps } from './Breadcrumb.types';
import Separator from './components/Separator/Separator';
import { defaultRenderPath } from './helpers/renderHelpers';

const Breadcrumb = forwardRef<HTMLUListElement, IBreadcrumbProps>(
  ({ className = '', size = 'medium', items, separator = <ChevronSmallRight />, ...rest }, ref): ReactElement => (
    <nav aria-label="Breadcrumb">
      <Styled.BreadcrumbWrapper className={classNames(BREADCRUMB_CLASS, className)} size={size} ref={ref} {...rest}>
        {items.map(({ name, path, icon, iconPosition = 'left', renderPath = defaultRenderPath }, index) => {
          const isLast = index === items.length - 1;

          return (
            <Styled.Breadcrumb key={name} size={size} aria-current={isLast ? 'page' : undefined}>
              {renderPath(path, name, icon, iconPosition, isLast)}
              {!isLast && <Separator separator={separator} />}
            </Styled.Breadcrumb>
          );
        })}
      </Styled.BreadcrumbWrapper>
    </nav>
  ),
);

export default Breadcrumb;
